import React from 'react';
import { Modal } from 'react-bootstrap';
import { Spinner } from 'hyperdb-utils';
import OwnerForm from '../../owner/components/Form';
import api from 'api';

class ModalCreateOwner extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    this.props.api.owner.initCreateForm();
  }
  componentWillReceiveProps(nextProps) {
    const { submitSuccessful, savedObject } = this.props.api.getState('owner');
    if (submitSuccessful) {
      this.props.onOwnerCreated(savedObject.id);
    }
  }
  render() {
    const { formLoaded, objectData, loading } = this.props.api.getState('owner');
    return (
      <Modal show={ true } onHide={ this.props.onClose } backdrop="static" keyboard={ false }>
        <Modal.Header closeButton>
          <Modal.Title>Create owner</Modal.Title>
        </Modal.Header>
        <Modal.Body className="box">
          <Spinner show={ loading } />
          { formLoaded ? <OwnerForm api={ this.props.api } objectData={ objectData } /> : null }
        </Modal.Body>
        <Modal.Footer>
          <button onClick={ this.props.onClose } type="button" className="btn btn-sm btn-default">Cancel</button>
          <button onClick={ this.handleSubmit } disabled={ loading } type="button" className="btn btn-sm btn-success">Create</button>
        </Modal.Footer>
      </Modal>
    );
  }
  handleSubmit() {
    const owner = this.props.api.getState('owner').objectData;
    this.props.api.owner.submitOwner({ objectData: owner });
  }
}

ModalCreateOwner.propTypes = {
  api: React.PropTypes.object,
  onClose: React.PropTypes.func,
  onOwnerCreated: React.PropTypes.func,
};

export default api.connect(ModalCreateOwner);



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/ModalCreateOwner.jsx